"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var IntroPage = function IntroPage() {
  var introViewContent = document.querySelector('.preparation-tool-intro-view .component-content');
  var history = (0, _reactRouterDom.useHistory)();

  var handleInitButton = function handleInitButton() {
    var initLink = document.querySelector('.preparation-tool-flex-spot .component-content button#init');

    if (initLink) {
      initLink.addEventListener('click', function (e) {
        history.push('overview');
      });
    }
  };

  (0, _react.useEffect)(function () {
    typeof dataLayer !== 'undefined' ? dataLayer.push({
      'event': 'vpv',
      'vpv': "".concat(window.location.href, "/step1")
    }) : null;
    handleInitButton();
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: introViewContent.innerHTML
    }
  });
};

var _default = (0, _reactRouterDom.withRouter)(IntroPage);

exports["default"] = _default;